import { styled } from '@mui/material/styles';
import MUIButton from '@mui/material/Button';
import { ColorContext } from '../../../interfaces/App';

const getBackgroundColor = (variant: string, color: ColorContext) => {
  if (variant === 'contained' && color === 'primary')
    return 'var(--primary-color)';
  if (variant === 'contained' && color === 'secondary') return '#fff';
  if (variant === 'contained' && color === 'success')
    return 'var(--success-color)';
  return; // the background color from MUI button
};

const getColor = (variant: string, color: ColorContext) => {
  if (variant === 'contained' && color === 'primary') return '#fff !important';
  if (variant === 'contained' && color === 'secondary')
    return 'var(--primary-text-color)';
  if (variant === 'text' && color === 'primary') return '#fff';
};

const getHeight = (size: 'small' | 'medium' | 'large') => {
  switch (size) {
    case 'small':
      return '44px';
    case 'large':
      return '56px';
    default:
      return '50px';
  }
};

const getDefaultPadding = (size: 'small' | 'medium' | 'large') => {
  switch (size) {
    case 'small':
      return '0.5rem 1.5rem';
    case 'large':
      return '1.5rem 4.5rem';
    default:
      return '1rem 3rem';
  }
};

interface StyledButtonProps {
  color: ColorContext;
  variant: string;
  size?: 'small' | 'medium' | 'large';
  padding?: string;
}

const StyledButton = styled(MUIButton)<StyledButtonProps>`
  font-family: var(--default-fonts);
  font-weight: 700;
  padding: ${({ padding, size }) => padding || getDefaultPadding(size!)};
  background-color: ${({ variant, color }) =>
    getBackgroundColor(variant!, color!)};
  color: ${({ variant, color }) => getColor(variant!, color!)};
  height: ${({ size }) => getHeight(size!) || 'auto'};
  box-shadow: none !important;

  &:hover {
    box-shadow: none !important;
  }

  &:active {
    box-shadow: none !important;
  }

  &:focus {
    box-shadow: none !important;
  }

  &.Mui-disabled {
    opacity: 0.4;
    pointer-events: none;
  }
`;

export default StyledButton;
